export const BARU_CONDITION = 1
export const BEKAS_CONDITION = 0